export const TEST_ID = 'plusIcon';
